<template lang="pug">
  span {{output}}
</template>
<script>
export default {
  props: {
    time:{
      default:'00:00'
    }
  },
  computed:{
    output(){
      if(this.time!=null){
        let t = this.time.split(":")
        if (t[0] > 12){
          return (t[0] - 12) + ':' +t[1]+" pm"
        }else{
          return this.time + " am"
        }
      }else{
        return ''
      }
    }
  }
}
</script>

